module.exports = __webpack_public_path__ + "Secure Icon.6ccf5c22.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/landing/Secure Icon.png
// module id = WVw/
// module chunks = 0